// extracted by mini-css-extract-plugin
export default {"blogBody":"Blog_blogBody__dqoSn","BlogButtonBox":"Blog_BlogButtonBox__U+G0P","BlogButtonLoad":"Blog_BlogButtonLoad__SoWnB"};